/**
 * SEO programmatic state data for /glp1-telehealth/:state pages.
 *
 * FLORIDA-ONLY LAUNCH: GLPFlo is currently licensed and shipping only in
 * Florida. Additional states will be added here as pharmacy licensing
 * comes online. Requests for any other slug are redirected to /florida
 * by StateLandingPage.js.
 */

export const STATES = {
  florida: {
    name: "Florida",
    abbr: "FL",
    slug: "florida",
    transit: "next-day (1 business day)",
    transitNote:
      "Our compounding partner ships from a temperature-monitored facility in Florida, so Floridian patients are usually receiving vials within 18-24 hours of dispatch.",
    climate: "subtropical / hot",
    climateNote:
      "Florida's heat is the most common reason patients ask about warm-on-arrival vials. The short answer is that compounded semaglutide and tirzepatide tolerate well above 86 °F for the few hours a porch package sees during a Florida afternoon — see /shipping-study for the FDA-label citations.",
    cities: ["Miami", "Tampa", "Orlando", "Jacksonville", "Fort Lauderdale", "St. Petersburg"],
    population: "~22 million residents",
    legalNote:
      "Florida explicitly permits the practice of telemedicine under Florida Statute 456.47, including the issuance of non-controlled prescriptions following an appropriate patient evaluation by a Florida-licensed provider. GLPFlo conducts that evaluation asynchronously through HIPAA-compliant secure messaging — no live video call is required. Compounded GLP-1 medications are non-controlled, so no DEA registration is needed.",
    keyMessage:
      "Same-state shipping means Florida patients see the shortest transit times in the country — and the lowest cold-chain risk.",
  },
};
